import { styled } from '@mui/material/styles'
import MuiButton from '@mui/material/Button'

export const ButtonFooter = styled(MuiButton, {
  name: 'ButtonFooter',
  slot: 'Root',
  skipSx: true,
})`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 22px;
  text-transform: capitalize;
  color: #19305a;
  margin-top: 8px;
  margin-bottom: 8px;
`
